import React, { useState, useEffect } from "react";

const ExportOptionsModal = ({ isOpen, onClose, onExport }) => {
    const [options, setOptions] = useState({
        all: false,
        projects: false,
        forms: false,
    });

    useEffect(() => {
        if (isOpen) {
            setOptions({ all: false, projects: false, forms: false });
        }
    }, [isOpen]);

    const handleChange = (key) => {
        setOptions((prev) => {
            const updated = {
                ...prev,
                [key]: !prev[key],
            };

            if (key === "all") {
                updated.projects = !prev.all;
                updated.forms = !prev.all;
            } else {
                updated.all = updated.projects && updated.forms;
            }

            return updated;
        });
    };

    const handleExport = () => {
        if (!options.projects && !options.forms) {
            alert("Please select at least one option.");
            return;
        }

        onExport({
            projects: options.projects,
            forms: options.forms,
        });
    };



    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="rounded-lg shadow-lg  w-full max-w-md bg-[#FFFFFF] p-6">
                <h2 className="text-lg font-bold mb-4">Export Options</h2>

                <div className="mb-4">
                    {["all", "projects", "forms"].map((key) => (
                        <label key={key} className="flex items-center space-x-2 mt-2 capitalize">
                            <input
                                type="checkbox"
                                checked={options[key]}
                                onChange={() => handleChange(key)}
                            />
                            <span>{key}</span>
                        </label>
                    ))}
                </div>

                <div className="flex justify-end gap-4">
                    <button
                        className="px-4 py-2 bg-gray-200 rounded"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        className="px-4 py-2 bg-blue-600 text-white rounded"
                        onClick={handleExport}
                    >
                        Export
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ExportOptionsModal;
